import { FormField, SelectOption } from '@components/shared/FormField'
import { VersionYear } from '@models/Version'
import { store } from '@stores/Store'
import { dataVersions } from '@utils/data'
import { Form } from 'antd'
import { observer } from 'mobx-react'
import React, { FunctionComponent } from 'react'
import styles from './VersionPanel.module.scss'

interface VersionPanelFormData {
  version: VersionYear
}

// Version switcher for the dormant multi-version mechanism. SimulatorPage only
// renders it when the registry holds 2+ live versions, so with a single version
// this component stays invisible. Labels resolve via LocalizationHelper's
// per-year getters, a new calculation version adds a getter there plus its
// translation row (explicit on purpose, no year derivation).
export const VersionPanel: FunctionComponent = observer(() => {
  const { globalStore, localizationHelper } = store

  const onValuesChange = (data: VersionPanelFormData) => {
    globalStore.setVersionYear(data.version)
  }

  const options: SelectOption<VersionYear>[] = dataVersions.map((option) => ({
    label: localizationHelper[option.year],
    value: option.year
  }))

  const version = globalStore.versionYear
  return (
    <div className={styles['panel-wrapper']}>
      <Form layout='vertical' initialValues={{ version }} onValuesChange={onValuesChange}>
        <FormField name="version" type='select' label='VERSION_TITLE' tooltip='VERSION_TOOLTIP' options={options} />
      </Form>
    </div>
  )
})
